import { useState } from 'react';
import translator from '@Components/Utilities/Translator';
import useScrollPosition from '@react-hook/window-scroll';
import usePassiveLayoutEffect from '@react-hook/passive-layout-effect';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const ScrollToTop = (props) => {

    const windowSize = useWindowSize();
    const scrollY = useScrollPosition();
    const onClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'scrolltop'
        });
    };

    const [status, setStatus] = useState({
        listingControlBar: false,
        mobileOptionBar: false,
        detailContactBar: false,
        cookieBanner: false,
        osanoCookieWidget: false
    });

    usePassiveLayoutEffect(function checkForScrollToTopPushers() {
        setStatus({
            listingControlBar: document.getElementsByClassName('mobile-listing-control-bar').length > 0,
            mobileOptionBar: document.getElementsByClassName('mobile-option-bar').length > 0,
            detailContactBar: document.getElementsByClassName('detail-contact-bar').length > 0,
            cookieBanner: document.getElementsByClassName('cookie-banner').length > 0,
            osanoCookieWidget: document.getElementsByClassName('osano-cm-widget--position_right').length > 0
        });
    }, [scrollY]);

    const getBottomPosition = () => {
        let bottom = 0;
        if (status.listingControlBar) {
            let listingControlBar = document.getElementsByClassName('mobile-listing-control-bar')[0];
            if (listingControlBar && windowSize.width < 650) {

                const listingControlBarRect = listingControlBar.getBoundingClientRect();
                const footerRect = document.getElementsByClassName('site-footer')?.[0]?.getBoundingClientRect();

                if (footerRect) {
                    if (listingControlBarRect.bottom >= footerRect.top - 10) {
                        bottom = 10;
                    }
                    else {
                        bottom += (listingControlBar.offsetHeight + 10);
                    }
                }
                else {
                    bottom += (listingControlBar.offsetHeight + 10);
                }
            }
        }

        if (status.mobileOptionBar) {
            let mobileOptionBar = document.getElementsByClassName('mobile-option-bar')?.[0];
            if (mobileOptionBar) {
                bottom += mobileOptionBar.offsetHeight;
            }
        }

        if (status.detailContactBar) {
            let detailContactBar = document.getElementsByClassName('detail-contact-bar')?.[0];
            if (detailContactBar) {
                bottom += detailContactBar.offsetHeight;
            }
        }

        if (status.cookieBanner) {
            let cookieBanner = document.getElementsByClassName('cookie-banner')?.[0];
            if (cookieBanner) {
                bottom += cookieBanner.offsetHeight;
            }
        }

        if (status.osanoCookieWidget) {
            let osanoCookieWidget = document.getElementsByClassName('osano-cm-widget--position_right')?.[0];
            if (osanoCookieWidget) {
                bottom += osanoCookieWidget.offsetHeight;
            }
        }

        if (bottom > 0) return `${bottom + 10}px`;
        return '';
    };

    return (scrollY > 1400) ? (
        <div role='button' tabIndex='0' title={translator.translate('sandhills.tradepubwebsite.mvc.scrolltotop')} onKeyDown={(e) => { if (e.key === 'Enter') onClick() }} className='scrollToTop' onClick={onClick} style={{ bottom: getBottomPosition() }}>
            <a>
                <i className='fas fa-arrow-up' aria-hidden='true'></i>
                <br />
                {translator.translate('sandhills.top').toString()}
            </a>
        </div>
    ) : (
        <></>
    );
};

const toggleScrollToTop = (show) => {
    let el = document.getElementsByClassName('scrollToTop')?.[0];
    if (el?.style) el.style.display = (show ? 'block' : 'none');
};

export default ScrollToTop;
export { toggleScrollToTop };